import React from 'react'
import PropTypes from 'prop-types'
import TimeFromNow from 'Components/TimeFromNow'
import RatingBlock from 'Components/RatingBlock'

const CourseReview = ({ review }) => (
  <>
    {review && (
      <>
        <div className="bg-gray-50 p-2 border border-gray-200 rounded-lg shadow-md">
          <div className="flex p-2">
            <p className="text-base flex text-gray-700 mr-2">
              {review.user.name}
            </p>
            <RatingBlock rating={review.rating} size="small" />
          </div>
          <div
            className="p-2"
            style={{
              borderBottomLeftRadius: '4px',
              borderBottomRightRadius: '4px',
            }}
          >
            <p className="text-base text-gray-700">{review.body}</p>
            <span className="text-sm text-gray-500">
              Updated&nbsp;
              <TimeFromNow value={review.modifiedOn} />
            </span>
          </div>
        </div>
      </>
    )}
  </>
)

CourseReview.propTypes = {
  review: PropTypes.object.isRequired,
}

export default CourseReview
